import { getEnv } from '@/lib/utils/common/getEnv';

/**
 * Check if developer tools should be enabled.
 * Dev tools are only available in development and staging environments.
 */
export const isDevToolsEnabled = (): boolean => {
  // Check if we're in development mode (localhost)
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return true;
  }

  const env = getEnv();

  if (env.apiBaseUrl?.endsWith('.dev')) {
    return true;
  }

  if (env.namespace?.includes('stage')) {
    return true;
  }

  // Disable in production
  return false;
};
